class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimer = null;
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    if (this.hoverMediaQuery.matches) {
      this.addEventListener('mouseenter', this.onHoverIn.bind(this));
      this.addEventListener('mouseleave', this.onHoverOut.bind(this));
      this.querySelector('summary')?.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onSummaryClick(event) {
    // Keep dropdown open on click while hovering; hover already controls open/close.
    if (this.hoverMediaQuery.matches) {
      event.preventDefault();
      this.open();
    }
  }

  onHoverIn() {
    clearTimeout(this.hoverCloseTimer);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.open();
  }

  onHoverOut() {
    this.hoverCloseTimer = setTimeout(() => this.close(), 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
